import { render, staticRenderFns } from "./MobilePageContainer.vue?vue&type=template&id=67bb6352&scoped=true"
var script = {}
import style0 from "./MobilePageContainer.vue?vue&type=style&index=0&id=67bb6352&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bb6352",
  null
  
)

export default component.exports